import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Check, MapPinSimpleArea, Warning } from "@phosphor-icons/react";
import RevampNavbar from "../RevampNavbar";
import { Link, NavLink, useParams, useLocation } from "react-router-dom";
import { API_PATHS } from "../../api/apiPaths";
import { API_BASE_URL } from "../../api/apiBaseUrl";
import { http } from "../../api/httpClient";
import Logo from "../../assets/logo.png";
import VerifyMobileScreen from "../requirements/VerifyMobileScreen";
import "../requirements/requirements.css";
import "./claimAccount.css";
import {
  trackClaimAccountStart,
  trackClaimAccountSuccess,
} from "../../utils/analytics";

const CLAIM_SUCCESS_BG = "#00c875";

function ClaimAccountSuccessScreen() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const onProfessionals =
    pathname === "/professionals" || pathname.startsWith("/professionals/");

  const IOS_STORE_URL = "https://apps.apple.com/app/hynt-homes-made-easy/id6752606030";
  const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=com.hynt.app";
  // const FALLBACK_URL = "https://hynt.co.in/";
  const openAndroidStoreLink = (target = "_blank") => {
    const url = ANDROID_STORE_URL;
    if (typeof window === "undefined") return url;
    window.open(url, target);
    return url;
    };
    const openIosStoreLink = (target = "_blank") => {
    const url = IOS_STORE_URL;
    if (typeof window === "undefined") return url;
    window.open(url, target);
    return url;
    };

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    trackClaimAccountSuccess({ buttonName: "Complete" });
  }, []);

  return (
    <div
    className="claim-account-success-screen"
    style={{ backgroundColor: CLAIM_SUCCESS_BG }}
    role="document"
    aria-labelledby="claim-success-title"
  >
      {/* <div className="claim-account-success-top-wrap">
        <header className="claim-account-success-topbar">
          <Link
            to="/"
            className="claim-account-success-logo-link"
            onClick={() => setMenuOpen(false)}
          >
            <img src={Logo} alt="HYNT" className="claim-account-success-logo" width={96} height={32} />
          </Link>
          <button
            type="button"
            className="claim-account-success-menu-toggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </header>
        {menuOpen ? (
          <nav className="claim-account-success-menu-panel" aria-label="Main">
            <NavLink
              to={onProfessionals ? "/" : "/professionals"}
              end
              className="claim-account-success-menu-link"
              onClick={() => setMenuOpen(false)}
            >
              {onProfessionals ? "For Homeowners" : "For Professionals"}
            </NavLink>
            <NavLink
              to="/careers"
              end
              className="claim-account-success-menu-link"
              onClick={() => setMenuOpen(false)}
            >
              Careers
            </NavLink>
            <NavLink
              to="/contact"
              end
              className="claim-account-success-menu-link"
              onClick={() => setMenuOpen(false)}
            >
              Contact Us
            </NavLink>
          </nav>
        ) : null}
      </div> */}
      <RevampNavbar color={true}/>

      <main className="claim-account-success-main" role="status">
        <div className="claim-account-success-mark" aria-hidden="true">
          <Check size={44} weight="bold" color={CLAIM_SUCCESS_BG} />
        </div>
        <h1 id="claim-success-title" className="claim-account-success-title">
          Your profile is now live
        </h1>
        <p className="claim-account-success-desc">
          You can start uploading projects so your work reaches more people.
        </p>
        <Link to="/" className="claim-account-success-proceed">
          Proceed
        </Link>

      <p className="claim-account-success-desc">
              Download app to continue 
            </p>
            <div className="create-business-success-store-wrap">
              <button type="button" onClick={openIosStoreLink}>
                <img src="/appstoreNew.svg" alt="Download on App Store" />
              </button>
              <button type="button" onClick={openAndroidStoreLink}>
                <img src="/playstoreNew.svg" alt="Get it on Google Play" />
              </button>
            </div>
      </main>
    </div>
  );
}

function ClaimAccountExistsScreen() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const onProfessionals =
    pathname === "/professionals" || pathname.startsWith("/professionals/");

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div className="claim-account-exists-screen" role="document" aria-labelledby="claim-exists-title">
      {/* <div className="claim-account-exists-top-wrap">
        <header className="claim-account-exists-topbar">
          <Link
            to="/"
            className="claim-account-exists-logo-link"
            onClick={() => setMenuOpen(false)}
          >
            <img src={Logo} alt="HYNT" className="claim-account-exists-logo" width={96} height={36} />
          </Link>
          <button
            type="button"
            className="claim-account-exists-menu-toggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </header>
        {menuOpen ? (
          <nav className="claim-account-exists-menu-panel" aria-label="Main">
            <NavLink
              to={onProfessionals ? "/" : "/professionals"}
              end
              className="claim-account-exists-menu-link"
              onClick={() => setMenuOpen(false)}
            >
              {onProfessionals ? "For Homeowners" : "For Professionals"}
            </NavLink>
            <NavLink
              to="/careers"
              end
              className="claim-account-exists-menu-link"
              onClick={() => setMenuOpen(false)}
            >
              Careers
            </NavLink>
            <NavLink
              to="/contact"
              end
              className="claim-account-exists-menu-link"
              onClick={() => setMenuOpen(false)}
            >
              Contact Us
            </NavLink>
          </nav>
        ) : null}
      </div> */}
      <RevampNavbar />

      <main className="claim-account-exists-main" role="alert">
        <div className="claim-account-exists-icon" aria-hidden="true">
          <Warning size={72} weight="regular" color="#111111" />
        </div>
        <h1 id="claim-exists-title" className="claim-account-exists-title">
          Your profile seems to already exist.
        </h1>
        <p className="claim-account-exists-subtitle">Contact HYNT support to resolve this.</p>
        <Link to="/contact" className="claim-account-exists-cta" onClick={() => setMenuOpen(false)}>
          Contact support
        </Link>
      </main>
    </div>
  );
}

function normalizeIndianMobile(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith("0")) return digits.slice(1);
  return digits;
}

function isValidIndianMobile10(digits) {
  return /^[6789]\d{9}$/.test(digits);
}

function extractApiMessage(payload) {
  if (!payload || typeof payload !== "object") return null;
  return payload.message || payload.error || payload.msg || null;
}

function isAccountAlreadyExistsFromMessage(text) {
  const t = String(text || "").toLowerCase();
  if (!t) return false;
  return /already exist|already exists|account already|profile already|user already|duplicate|already registered|already claimed|already been claimed|been claimed|already in use|already associated|phone.*already|number.*already|mobile.*already/.test(
    t,
  );
}

function isAccountAlreadyExistsError(error, fallbackMessage) {
  if (error?.response?.status === 409) return true;
  const body = error?.response?.data;
  const combined = [
    fallbackMessage,
    typeof error?.message === "string" ? error.message : "",
    extractApiMessage(body),
    typeof body?.error === "string" ? body.error : "",
    body?.code,
    body?.errorCode,
    body?.error_code,
  ]
    .filter(Boolean)
    .join(" ");
  return isAccountAlreadyExistsFromMessage(combined);
}

function ensureApiSuccess(payload, fallbackMessage) {
  if (payload && typeof payload === "object" && payload.success === false) {
    throw new Error(extractApiMessage(payload) || fallbackMessage);
  }
}

/** Backend may nest the profile under `user` or expose flat fields. */
function unwrapDetails(payload) {
  if (!payload || typeof payload !== "object") return null;
  return payload.data ?? payload;
}

function resolveVerificationUserId(details, linkUserId) {
  if (!details || typeof details !== "object") return linkUserId;
  const nestedUserId = details.user && typeof details.user === "object" ? details.user._id : null;
  const explicit =
    details.userId ??
    details.profileUserId ??
    details.claimForUserId ??
    nestedUserId;
  if (explicit != null && String(explicit).trim() !== "") return String(explicit);
  return linkUserId;
}

function resolveInitiateUserId(details, linkUserId) {
  if (!details || typeof details !== "object") return linkUserId;
  const fromApi =
    details.claimId ??
    details.claimTokenId ??
    details.linkId ??
    details.inviteId;
  if (fromApi != null && String(fromApi).trim() !== "") return String(fromApi);
  return linkUserId;
}

function getField(details, key) {
  const nested = details?.user && typeof details.user === "object" ? details.user : null;
  const topVal = details?.[key];
  if (topVal != null && topVal !== "") return topVal;
  if (nested && nested[key] != null && nested[key] !== "") return nested[key];
  return undefined;
}

/** Strip state/region: keep segment before first comma (ASCII or fullwidth). */
function takeCitySegmentOnly(value) {
  const t = String(value ?? "").trim();
  if (!t) return "";
  const m = t.match(/^[^,，;|]+/);
  return m ? m[0].trim() : t;
}

/** Prefer dedicated city fields; otherwise parse `location` string/object. Always drops text after first comma. */
function resolveLocationCityOnly(details) {
  if (!details || typeof details !== "object") return "";

  const cityDirect =
    getField(details, "city") || getField(details, "cityName") || getField(details, "town");
  if (cityDirect != null && String(cityDirect).trim() !== "") {
    return takeCitySegmentOnly(cityDirect);
  }

  const addr = details.address ?? details.user?.address;
  if (addr && typeof addr === "object") {
    const fromAddr = addr.city || addr.town;
    if (fromAddr != null && String(fromAddr).trim() !== "") {
      return takeCitySegmentOnly(fromAddr);
    }
  }

  const loc = getField(details, "location");
  if (loc == null || loc === "") return "";
  if (typeof loc === "object") {
    const c = loc.city || loc.town || loc.name;
    if (c != null && String(c).trim() !== "") {
      return takeCitySegmentOnly(c);
    }
    return "";
  }

  return takeCitySegmentOnly(loc);
}

function resolveProfilePicUrl(details) {
  const candidates = [
    details?.profilePic,
    details?.profilePicture,
    details?.avatar,
    details?.image,
    details?.photo,
    details?.user?.profilePic,
    details?.user?.profilePicture,
    details?.user?.avatar,
    details?.user?.image,
    details?.user?.photo,
  ];

  const rawCandidate = candidates.find((v) => {
    if (!v) return false;
    if (typeof v === "string") return v.trim() !== "";
    if (typeof v === "object") return Boolean(v?.url);
    return false;
  });
  if (!rawCandidate) return null;

  const picRaw = typeof rawCandidate === "object" ? rawCandidate?.url : rawCandidate;
  const pic = String(picRaw).trim();
  if (!pic) return null;
  if (pic.startsWith("data:")) return pic;
  if (pic.startsWith("http://") || pic.startsWith("https://")) return pic;
  if (pic.startsWith("/")) return `${API_BASE_URL}${pic}`;
  return pic;
}

function resolveBusinessName(details) {
  return (
    getField(details, "businessName") ||
    getField(details, "companyName") ||
    getField(details, "professionalCategory") ||
    ""
  );
}

function resolveInitials(nameOrFallback) {
  const s = String(nameOrFallback || "").trim();
  if (!s) return "?";
  const parts = s.split(/\s+/).filter(Boolean);
  const initials = parts.slice(0, 2).map((p) => p[0]).join("");
  return initials.toUpperCase();
}

function resolveActiveSinceYear(details) {
  const raw =
    getField(details, "activeSince") ||
    getField(details, "active_since") ||
    getField(details, "activeSinceYear");
  if (raw == null) return undefined;

  const s = String(raw).trim();
  if (!s) return undefined;

  const m = s.match(/\b(19\d{2}|20\d{2})\b/);
  if (m?.[1]) return m[1];

  const digits = s.replace(/\D/g, "");
  if (digits.length === 4) return digits;

  return undefined;
}

function getYearsSince(dateValue) {
  if (!dateValue) return 0;
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return 0;
  const now = new Date();
  const years = now.getFullYear() - date.getFullYear();
  const monthDelta = now.getMonth() - date.getMonth();
  const hasNotCompletedYear =
    monthDelta < 0 || (monthDelta === 0 && now.getDate() < date.getDate());
  return Math.max(0, years - (hasNotCompletedYear ? 1 : 0));
}

function resolveDisplayName(details) {
  if (!details || typeof details !== "object") return "";
  const first = getField(details, "firstName");
  const last = getField(details, "lastName");
  const combined = [first, last].filter(Boolean).join(" ").trim();
  if (combined) return combined;
  return (
    getField(details, "name") ||
    getField(details, "fullName") ||
    getField(details, "businessName") ||
    getField(details, "companyName") ||
    ""
  );
}

function resolveProjectCount(details) {
  const raw =
    getField(details, "projectCount") ??
    getField(details, "projects") ??
    getField(details, "totalProjects") ??
    getField(details, "completedProjects") ??
    getField(details, "noOfProjects") ??
    getField(details, "project_count") ??
    getField(details, "projectsCount");
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

function resolveYearsExp(details) {
  const direct = Number(
    getField(details, "experienceYears") ??
      getField(details, "yearsOfExperience") ??
      getField(details, "experience"),
  );
  if (Number.isFinite(direct) && direct >= 0) return Math.floor(direct);
  const since = getField(details, "activeSince") || getField(details, "active_since");
  const fromDate = getYearsSince(since);
  if (fromDate > 0) return fromDate;
  const yearStr = resolveActiveSinceYear(details);
  if (yearStr) {
    const startYear = parseInt(yearStr, 10);
    if (!Number.isNaN(startYear)) {
      return Math.max(0, new Date().getFullYear() - startYear);
    }
  }
  return 0;
}

function ClaimAccountPage() {
  const { userId: linkUserId } = useParams();

  const [loadState, setLoadState] = useState({ status: "loading", error: null });
  const [details, setDetails] = useState(null);

  const [step, setStep] = useState("view");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [formError, setFormError] = useState(null);
  const [isRequestingOtp, setIsRequestingOtp] = useState(false);
  const [isSubmittingClaim, setIsSubmittingClaim] = useState(false);

  useEffect(() => {
    trackClaimAccountStart({ buttonName: "Open claim link" });
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!linkUserId) {
        setLoadState({ status: "error", error: "Invalid claim link." });
        return;
      }

      setLoadState({ status: "loading", error: null });
      try {
        const res = await http.get(API_PATHS.claimAccDetails(linkUserId));
        console.log("res", res);
        console.log("res.data", res.data);
        ensureApiSuccess(res?.data, "Could not load account details.");
        const body = unwrapDetails(res.data);
        if (cancelled) return;
        if (!body || typeof body !== "object") {
          setLoadState({ status: "error", error: "Could not load account details." });
          return;
        }
        setDetails(body);
        setLoadState({ status: "ready", error: null });
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Could not load account details.";
        if (!cancelled && isAccountAlreadyExistsError(error, message)) {
          setLoadState({ status: "account_exists", error: null });
          return;
        }
        if (!cancelled) setLoadState({ status: "error", error: message });
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [linkUserId]);

  const profilePicUrl = useMemo(() => resolveProfilePicUrl(details), [details]);
  const displayName = useMemo(() => resolveDisplayName(details), [details]);
  const professionalType = useMemo(
    () => String(getField(details, "professionalType") || "").trim(),
    [details],
  );
  const locationText = useMemo(() => resolveLocationCityOnly(details), [details]);
  const projectCount = useMemo(() => resolveProjectCount(details), [details]);
  const yearsExp = useMemo(() => resolveYearsExp(details), [details]);
  const initials = useMemo(() => resolveInitials(displayName || resolveBusinessName(details)), [
    details,
    displayName,
  ]);
  const hasProfileSignal = Boolean(
    displayName ||
      profilePicUrl ||
      professionalType ||
      locationText ||
      projectCount > 0 ||
      yearsExp > 0,
  );

  const initiateUserId = useMemo(
    () => resolveInitiateUserId(details, linkUserId),
    [details, linkUserId],
  );

  const verificationUserId = useMemo(
    () => resolveVerificationUserId(details, linkUserId),
    [details, linkUserId],
  );

  const handleStartClaim = () => {
    setFormError(null);
    setPhoneNumber("");
    setStep("verify");
  };

  const mapClaimError = useCallback((error) => {
    return (
      extractApiMessage(error?.response?.data) ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Something went wrong."
    );
  }, []);

  const requestClaimOtp = useCallback(async () => {
    setFormError(null);
    const phone = normalizeIndianMobile(phoneNumber);
    if (!isValidIndianMobile10(phone)) {
      throw new Error("Enter a valid 10-digit Indian mobile number.");
    }
    const phoneWith91 = `91${phone}`;
    setIsRequestingOtp(true);
    try {
      const response = await http.post(API_PATHS.CLAIM_INITIATE, {
        phoneNumber: phoneWith91,
        userId: initiateUserId,
      });
      ensureApiSuccess(response?.data, "Could not send OTP.");
    } catch (error) {
      const message = mapClaimError(error);
      if (isAccountAlreadyExistsError(error, message)) {
        setStep("account_exists");
        const silent = new Error(message);
        silent.skipVerifyAlert = true;
        throw silent;
      }
      setFormError(message);
      throw new Error(message);
    } finally {
      setIsRequestingOtp(false);
    }
  }, [initiateUserId, mapClaimError, phoneNumber]);

  const resendClaimOtp = useCallback(async () => {
    await requestClaimOtp();
  }, [requestClaimOtp]);

  const verifyClaimOtp = useCallback(
    async (otpValue) => {
      setFormError(null);
      const phone = normalizeIndianMobile(phoneNumber);
      const phoneWith91 = `91${phone}`;
      const otpTrimmed = String(otpValue || "").replace(/\D/g, "");
      if (!isValidIndianMobile10(phone)) {
        throw new Error("Enter a valid 10-digit Indian mobile number.");
      }
      if (otpTrimmed.length < 4) {
        throw new Error("Enter the OTP you received.");
      }
      trackClaimAccountStart({ buttonName: "Complete" });
      setIsSubmittingClaim(true);
      try {
        const response = await http.post(API_PATHS.CLAIM_END, {
          phoneNumber: phoneWith91,
          userId: verificationUserId,
          otp: otpTrimmed,
        });
        ensureApiSuccess(response?.data, "Verification failed.");
        setStep("success");
      } catch (error) {
        const message = mapClaimError(error);
        if (isAccountAlreadyExistsError(error, message)) {
          setStep("account_exists");
          return;
        }
        setFormError(message);
        throw new Error(message);
      } finally {
        setIsSubmittingClaim(false);
      }
    },
    [mapClaimError, phoneNumber, verificationUserId],
  );

  const handleBackFromVerify = () => {
    setFormError(null);
    setPhoneNumber("");
    setStep("view");
  };

  if (loadState.status === "loading") {
    return (
      <div className="claim-account-page">
        <div className="claim-account-shell claim-account-loading">Loading…</div>
      </div>
    );
  }

  if (loadState.status === "account_exists") {
    return <ClaimAccountExistsScreen />;
  }

  if (loadState.status === "error") {
    return (
      <div className="claim-account-page">
        <div className="claim-account-shell">
          <h1 className="claim-account-title">Claim account</h1>
          <div className="claim-account-error" role="alert">
            {loadState.error}
          </div>
          <Link to="/" className="claim-account-btn-secondary" style={{ display: "inline-block", textAlign: "center", textDecoration: "none", lineHeight: "48px" }}>
            Back to home
          </Link>
        </div>
      </div>
    );
  }

  if (loadState.status === "ready" && step === "success") {
    return <ClaimAccountSuccessScreen />;
  }

  if (loadState.status === "ready" && step === "account_exists") {
    return <ClaimAccountExistsScreen />;
  }

  return (
    <div className="claim-account-page">
      <div className="claim-account-shell">
        <>
          {step === "view" && (
              <>
                <header className="claim-account-hero">
                  <h1 className="claim-account-title">
                    Claim your
                    <br />
                    <span className="claim-account-title-accent">HYNT account</span>
                  </h1>
                  <p className="claim-account-subtitle">
                    Confirm this profile belongs to you. We&apos;ll verify your mobile number with a
                    one-time code.
                  </p>
                </header>

                <section
                  className="claim-account-card claim-account-profile-card"
                  aria-labelledby="claim-profile-heading"
                >
                  <h2 id="claim-profile-heading" className="claim-account-sr-only">
                    Profile to claim
                  </h2>

                  <div className="claim-account-profile-row">
                    <div className="claim-account-avatar" aria-hidden="true">
                      {profilePicUrl ? (
                        <img className="claim-account-avatar-img" src={profilePicUrl} alt="" />
                      ) : (
                        <div className="claim-account-avatar-fallback">{initials}</div>
                      )}
                    </div>

                    <div className="claim-account-profile-body">
                      <div className="claim-account-name-row">
                        <span className="claim-account-profile-name">
                          {displayName || "Your profile"}
                        </span>
                        {/* <span className="claim-account-name-badges" aria-hidden="true">
                          <svg
                            className="claim-account-sparkle-icon"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z"
                              fill="currentColor"
                            />
                          </svg>
                          {isVerified ? (
                            <span
                              className="claim-account-verified-badge"
                              role="img"
                              aria-label="Verified profile"
                            >
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                                <path
                                  d="M2.5 6L5 8.5L9.5 3"
                                  stroke="white"
                                  strokeWidth="1.75"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          ) : null}
                        </span> */}
                      </div>

                      {(professionalType || locationText) && (
                        <div className="claim-account-role-row">
                          {professionalType ? (
                            <span className="claim-account-job">{professionalType}</span>
                          ) : (
                            <span className="claim-account-job" aria-hidden="true" />
                          )}
                          {locationText ? (
                            <span className="claim-account-loc">
                              <MapPinSimpleArea
                                className="claim-account-pin-icon"
                                size={14}
                                weight="regular"
                                aria-hidden={true}
                              />
                              <span className="claim-account-loc-text">{locationText}</span>
                            </span>
                          ) : null}
                        </div>
                      )}

                      {(projectCount >= 0 || yearsExp >= 0) && (
                        <div className="claim-account-stats" aria-label="Profile summary">
                          {projectCount >= 0 ? (
                            <span className="claim-account-stats-projects">
                              {projectCount} {projectCount === 1 ? "Project" : "Projects"}
                            </span>
                          ) : null}
                          {projectCount >= 0 && yearsExp >= 0 ? (
                            <span className="claim-account-stats-divider" aria-hidden="true" />
                          ) : null}
                          {yearsExp >= 0 ? (
                            <span className="claim-account-stats-exp">
                              {yearsExp} {yearsExp === 1 ? "year" : "years"}/exp
                            </span>
                          ) : null}
                        </div>
                      )}

                      {!hasProfileSignal ? (
                        <p className="claim-account-card-empty">No details were returned for this link.</p>
                      ) : null}
                    </div>
                  </div>
                </section>

                <p className="claim-account-footnote">
                  You can make changes to your profile once you&apos;re logged in.
                </p>

                <div className="claim-account-actions claim-account-actions-proceed">
                  <button
                    type="button"
                    className="claim-account-btn-primary claim-account-btn-pill"
                    onClick={handleStartClaim}
                  >
                    Proceed
                  </button>
                </div>
              </>
            )}

            {step === "verify" && (
              <section className="claim-account-verify-shell" aria-labelledby="claim-verify-heading">
                {/* <h2 id="claim-verify-heading" className="claim-account-verify-heading">
                  Verify mobile number
                </h2> */}
                {formError ? (
                  <div className="claim-account-error" role="alert">
                    {formError}
                  </div>
                ) : null}
                <div className="claim-account-verify-inner">
                  <VerifyMobileScreen
                    phoneNumber={phoneNumber}
                    onPhoneChange={setPhoneNumber}
                    onBack={handleBackFromVerify}
                    onRequestOtp={requestClaimOtp}
                    onResendOtp={resendClaimOtp}
                    onVerify={verifyClaimOtp}
                    isRequestingOtp={isRequestingOtp}
                    isSubmitting={isSubmittingClaim}
                    eyebrowText="Claim your account"
                  />
                </div>
                <p className="claim-account-muted">
                  Standard SMS charges may apply. Do not share your OTP with anyone.
                </p>
              </section>
            )}
          </>
      </div>
    </div>
  );
}

export default ClaimAccountPage;
